export const GET_LAND_HISTORY_LIST = '/land_history/GET_LAND_HISTORY_LIST';

// for modal

export const GET_LAND_APPLICATIONS = '/land/get_land_application';
export const GET_SINGLE_LAND_APPLICATION = '/land/get_single_land_application';
export const CREATE_LAND_APPLICATION = '/land/create_land_application';
export const UPDATE_LAND_APPLICATION = '/land/update_land_application';

export const GET_LAND_APPRAISAL = '/land/get_land_appraisal';
export const GET_SINGLE_LAND_APPRAISAL = '/land/get_single_land_appraisal';
export const CREATE_LAND_APPRAISAL = '/land/create_land_appraisal';
export const UPDATE_LAND_APPRAISAL = '/land/update_land_appraisal';
export const REMOVE_LAND_APPRAISAL = '/land/remove_land_appraisal';

export const GET_LAND_PROPERTY_ASSESSMENT = '/land/get_land_property_assessment';
export const GET_SINGLE_LAND_PROPERTY_ASSESSMENT = '/land/get_single_land_property_assessment';
export const CREATE_LAND_PROPERTY_ASSESSMENT = '/land/create_land_property_assessment';
export const UPDATE_LAND_PROPERTY_ASSESSMENT = '/land/update_land_property_assessment';
export const REMOVE_LAND_PROPERTY_ASSESSMENT = '/land/remove_land_property_assessment';

export const GET_LAND_MARKET_VALUE = '/land/get_land_market_value';
export const GET_SINGLE_LAND_MARKET_VALUE = '/land/get_single_land_market_value';
export const CREATE_LAND_MARKET_VALUE = '/land/create_land_market_value';
export const UPDATE_LAND_MARKET_VALUE = '/land/update_land_market_value';
export const REMOVE_LAND_MARKET_VALUE = '/land/remove_land_market_value';

export const GET_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/get_land_record_of_sup_assessment';
export const GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/get_single_land_record_of_sup_assessment';
export const CREATE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/create_land_record_of_sup_assessment';
export const UPDATE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/update_land_record_of_sup_assessment';
export const REMOVE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/remove_land_record_of_sup_assessment';

export const GET_LAND_TRANSACTION = '/land/get_land_transaction';

export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_SINGLE_LAND_CLASS = '/land/get_single_land_class';

export const GET_ACTUAL_USES = '/get_actual_uses';

export const GET_ADJUSTMENT_FACTOR_LIST = '/land/get_assessment_level_list';

export const GET_TRANSACTION_CODES = '/get_transaction_codes';

export const GET_LAND_OWNER = '/get_land_owner';
export const GET_SINGLE_LAND_OWNER = '/get_single_land_owner';

export const GET_PROVINCE = 'NEW_BUSINESSES/get_provinces';
export const GET_MUNICIPALITIES = 'NEW_BUSINESSES/get_municipalities';
export const GET_BARANGAYS = 'NEW_BUSINESSES/get_barangays';


export const FORM_DATA = {
  rptax_transaction_code_id: '',
  rptax_owner_id: '',
  tdn: '',
  property_location_brgy_district: '',
  property_location_municipality: '',
  property_location_no_street: '',
  property_location_province_city: '',
  property_location_brgy_district_code: '',
  property_location_municipality_code: '',
  property_location_province_city_code: '',
  property_boundaries_north: '',
  property_boundaries_east: '',
  property_boundaries_south: '',
  property_boundaries_west: '',
  property_boundaries_land_sketch_photo_url: '',
  arp_no: '',
  pin: '',
  oct_tct_cloa_no: '',
  oct_tct_cloa_dated: '',
  survey_no: '',
  lot_no: '',
  blk: '',
  administrator_beneficial_user: '',
  administrator_beneficial_address: '',
  administrator_beneficial_telephone_no: '',
  administrator_beneficial_tin: '',
  effectivity_of_assessment_reassessment_qtr: '',
  effectivity_of_assessment_reassessment_yr: '',
  appraised_assessed_by: '',
  appraised_assessed_at: '',
  recommending_by: '',
  recommending_at: '',
  approved_by: '',
  approved_at: '',
  memoranda: '',
};

export const LAND_APPRAISAL_FORM_DATA = {
  rptax_land_classification_id: '',
  rptax_land_sub_classification_id: '',
  rptax_actual_use_id: '',
  area: '',
  classification: '',
  sub_classification: '',
  actual_use: '',
};

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  actual_use: '',
};

export const LAND_MARKET_VALUE_FORM_DATA = {
  rptax_land_adjustment_factor_id: '',
  adjustment_factor: '',
};

export const LAND_SUP_ASSESSMENT_FORM_DATA = {
  pin: '',
  arp_no: '',
  td_no: '',
  total_assessed_value: '',
  previous_owner: '',
  effectivity_of_assessment: '',
  ar_page_no: '',
  recording_person: '',
  date: '',
}

